import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PayloadCompanyType } from 'components/types/company';
import { http } from 'helpers/http';
import { useDispatch } from 'react-redux';
import { HIT_BOARD_STATUS } from 'redux/actions/board';
import { DO_LOADING } from 'redux/actions/loading';

const URL = process.env.REACT_APP_API;

interface DeleteCompanyTypes {
  company_id : string
}

export const useUpdateProfileBOCompany = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updateProfile: any) => {
      const response = await http.post(`${URL}cdn/upload`, updateProfile);
      return response.data?.data ? response.data?.data : response.data;
    },
    onError: (error: any) => {
      const errorMessage = error.message;
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'failed',
          message: errorMessage,
        },
      });
    },
  });
};

export const useUpdateBOCompany = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updateCompany: PayloadCompanyType) => {
      const response = await http.post(`${URL}bo-company/update`, updateCompany);
      return response.data;
    },
    onSuccess: (responseData) => {
      void queryClient.invalidateQueries({ queryKey: ['bo-company/list'] });
      const successMesage = responseData.message;
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'success',
          message: successMesage,
        },
      });
    },
    onError: (error: any) => {
      const errorMessage = error.message;
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'failed',
          message: errorMessage,
        },
      });
    },
    onSettled: () => {
      dispatch({ type: DO_LOADING, payload: false });
    },
  });
};

export const useDeleteBOCompany = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (deleteCompany: DeleteCompanyTypes) => {
      const response = await http.post(`${URL}bo-company/delete`, deleteCompany);
      return response.data;
    },
    onSuccess: (responseData) => {
      void queryClient.invalidateQueries({ queryKey: ['bo-company/list'] });
      const successMesage = responseData.message;
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'success',
          message: successMesage,
        },
      });
    },
    onError: (error: any) => {
      const errorMessage = error.message;
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'failed',
          message: errorMessage,
        },
      });
    },
    onSettled: () => {
      dispatch({ type: DO_LOADING, payload: false });
    },
  });
};
